import Vue from 'vue/dist/vue.esm.js';
import axios from 'axios'
import qs from 'qs'
import { Carousel, Slide } from 'vue-carousel';
import VModal from 'vue-js-modal'

Vue.use(VModal)

window.onload = function(){
  var testimonialShow = new Vue({
    el: "#testimonial",
    components: { Carousel, Slide },
    data: {
      role: "public",
      user_id: null,
      testimonial_images: [],
      isFavorited: false,
      modalImage: null,
      carouselPageNum: 0,
      modalImagePageNum: 0,
      showStockImage: true,
      testimonial_id: null
    },
    created: function() {
      const self = this
      self.testimonial_id = document.getElementById('testimonial_id').dataset.id;
      self.fetchTestimonialImages()
    },
    computed: {
      selectedStockImage: function() {
        return this.modalImage;
      },
    },
    methods: {
      fetchTestimonialImages() {
        const self = this
        axios.get(`/api/v1/testimonials/${this.testimonial_id}/testimonial_images.json`)
        .then(function (response) {
          self.testimonial_images = response.data
        })
      },
      showImageModal : function(index, e) {
        this.modalImagePageNum = index
        this.modalImage = e.currentTarget.src
        this.$modal.show('imageModal');
      },
      hideImageModal() {
        this.$modal.hide('imageModal');
      },
      changeModalImage(url) {
        this.modalImage = url
      },
      goToSlidePage(pageNum) {
        this.carouselPageNum = pageNum
        this.$refs.carousel.goToPage(pageNum);
      },
      goBack() {
        if(testimonialShow.modalImagePageNum > 0) {
          testimonialShow.modalImagePageNum = testimonialShow.modalImagePageNum - 1
        }

        testimonialShow.changeModalImage(testimonialShow.testimonial_images[testimonialShow.modalImagePageNum].image.thumb_600.url)
      },
      goForward() {
        if (testimonialShow.modalImagePageNum < testimonialShow.$refs.carousel.pageCount - 1) {
          testimonialShow.modalImagePageNum = testimonialShow.modalImagePageNum + 1
        }

        testimonialShow.changeModalImage(testimonialShow.testimonial_images[testimonialShow.modalImagePageNum].image.thumb_600.url)
      },
    },
  })

document.addEventListener('keyup', function(event) {
  let imageModal = document.getElementById("imageModal")

  if(event.which == 37) { //left key
    if(imageModal) {

      if(testimonialShow.modalImagePageNum > 0) {
        testimonialShow.modalImagePageNum = testimonialShow.modalImagePageNum - 1
      }
      testimonialShow.changeModalImage(testimonialShow.testimonial_images[testimonialShow.modalImagePageNum].image.thumb_600.url)

    } else {

      if(testimonialShow.carouselPageNum > 0) {
        testimonialShow.carouselPageNum = testimonialShow.carouselPageNum - 1
      }
      testimonialShow.goToSlidePage(testimonialShow.carouselPageNum)
    }

  }
  if(event.which == 39) { //right key
    if(imageModal) {

      if(testimonialShow.modalImagePageNum < testimonialShow.$refs.carousel.pageCount - 1) {
        testimonialShow.modalImagePageNum = testimonialShow.modalImagePageNum + 1
      }
      testimonialShow.changeModalImage(testimonialShow.testimonial_images[testimonialShow.modalImagePageNum].image.thumb_600.url)

    } else {

      if(testimonialShow.carouselPageNum < testimonialShow.$refs.carousel.pageCount - 1) {
        testimonialShow.carouselPageNum = testimonialShow.carouselPageNum + 1
      }
      testimonialShow.goToSlidePage(testimonialShow.carouselPageNum)
    }
  }
});
}